import { Box, Button, MenuItem, Select, Stack, Typography } from '@mui/material';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { useRegistry } from '../store/RegistryStore';

export default function PrototypeBar() {
  const { state, dispatch } = useRegistry();
  const logins = state.investorLogins.filter((login) => login.tenantId === 't-fides').slice(0, 12);
  return (
    <Box sx={{ bgcolor: '#0F172A', color: '#E2E8F0', px: { xs: 1.5, md: 3 }, py: 0.5 }}>
      <Stack
        useFlexGap
        direction="row"
        spacing={1.5}
        alignItems="center"
        sx={{ maxWidth: 1180, mx: 'auto', flexWrap: 'wrap', rowGap: 0.5 }}
      >
        <Typography variant="caption" sx={{ fontWeight: 700, color: '#FBBF24' }}>
          PROTOTYPE
        </Typography>
        <Typography variant="caption" sx={{ display: { xs: 'none', sm: 'inline' } }}>
          Viewing as
        </Typography>
        <Select
          size="small"
          variant="standard"
          value={state.currentInvestorLoginId}
          onChange={(event) =>
            dispatch({ type: 'SWITCH_INVESTOR', loginId: String(event.target.value) })
          }
          sx={{
            color: '#fff',
            fontSize: '0.75rem',
            '&:before, &:after': { display: 'none' },
            '& .MuiSvgIcon-root': { color: '#fff' },
          }}
          inputProps={{ 'aria-label': 'Investor persona' }}
        >
          {logins.map((login) => (
            <MenuItem key={login.id} value={login.id} sx={{ fontSize: '0.85rem' }}>
              {login.name} ({login.holderIds.length}{' '}
              {login.holderIds.length === 1 ? 'entity' : 'entities'})
            </MenuItem>
          ))}
        </Select>
        <Box sx={{ flex: 1 }} />
        <Button
          component={RouterLink}
          to="/manager"
          size="small"
          sx={{ color: '#C7D2FE', fontSize: '0.75rem', py: 0 }}
        >
          Manager view
        </Button>
        <Button
          component={RouterLink}
          to="/"
          size="small"
          sx={{
            color: '#C7D2FE',
            fontSize: '0.75rem',
            py: 0,
            display: { xs: 'none', sm: 'inline-flex' },
          }}
        >
          Walkthrough
        </Button>
      </Stack>
    </Box>
  );
}
